import React, { useMemo } from 'react';
import { PaymentMethod, TransactionCategory } from '@shipstation/financial-services-ui-components';

import { LoadingIndicator } from 'ui-components/components/loading-indicator';

import { SimpleModal } from '../../components/simple-modal';
import { PaymentUpdateBody, usePaymentUpdateContext } from './';

import { messages } from '../messages';
import style from './style.module.less';

const payByBankTypes = [PaymentMethod.PayByBankEU, PaymentMethod.PayByBankUS];

export const PaymentUpdateModal = (props) => {
  const { paymentType, onAction, isBillingInfoLoading, isPreloadingSession, isAddingNew } = usePaymentUpdateContext();
  const actionMessage = useMemo(() => {
    return isAddingNew && payByBankTypes.includes(paymentType) ? messages.continueToBank : messages.save;
  }, [paymentType, isAddingNew]);
  const isLoading = isBillingInfoLoading || isPreloadingSession;

  return (
    <SimpleModal
      actionMessage={actionMessage}
      bodyClassName={style.body}
      cancelMessage={messages.cancel}
      className={undefined}
      headerMessage={
        props.transactionCategory === TransactionCategory.Subscription ? messages.editSubscriptionBilling : messages.editShipstationBalance
      }
      onAction={onAction}
      onClose={props.onClose}
      size='medium'
    >
      {isLoading ? <LoadingIndicator /> : <PaymentUpdateBody {...props} />}
    </SimpleModal>
  );
};
